<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g stroke="currentColor" style="fill:#fff"><circle cx="12" cy="12" r="12" stroke="none" style="stroke:none"/><circle cx="12" cy="12" r="11.5" style="fill:none"/></g><g><path d="M0 0v10" style="stroke:#333;stroke-linecap:round;fill:none" transform="translate(11.999 7)" fill="currentColor"/><path d="M0 0v10" style="stroke:#333;stroke-linecap:round;fill:none" transform="rotate(90 2.5 14.5)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-btn-add',
});
</script>
